export default __webpack_public_path__ + "files/08367635c12f6eb6260722bc38d989cb.mp3";